<template>
  <div>
    <v-card>
      <v-card-title>
        Pendidikan <br />

        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Cari Pendidikan"
          single-line
          hide-details
          v-on:keyup.enter="getDataFromApi"
        ></v-text-field>
        <v-spacer></v-spacer>

        <v-btn color="primary" dark class="mb-2" @click="openTambah">
          Tambah
        </v-btn>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="text-h5">Pendidikan</span>
            </v-card-title>
            <v-card-text>
              <v-form
                ref="form"
                v-model="valid"
                lazy-validation
                class="pl-4 pr-4"
              >
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        dense
                        label="Nama Universitas"
                        required
                        v-model="currentData.nama_institusi"
                        :rules="currentData.namaRules"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        dense
                        label="Jurusan"
                        required
                        v-model="currentData.jurusan"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="Mulai Pendidikan"
                        v-model="currentData.mulai_pend"
                        type="month"
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="Akhir Pendidikan"
                        v-model="currentData.akhir_pend"
                        type="month"
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        dense
                        label="No Ijazah"
                        required
                        v-model="currentData.no_ijazah"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="Tanggal Ijazah"
                        v-model="currentData.tanggal_ijazah"
                        type="date"
                        dense
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-combobox
                        label="Jenjang"
                        clearable
                        dense
                        outlined
                        v-model="currentData.selectedJenjang"
                        :items="currentData.items_jenjang"
                        item-text="value"
                        :readonly="isEditable == 0"
                      ></v-combobox>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialog = false">
                Close
              </v-btn>
              <v-btn color="blue darken-1" text @click="doSave"> Save </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5"
              >Apa anda akan menghapus data ini?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Tidak</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >Ya</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card-title>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="list_data"
        :options.sync="options"
        :server-items-length="totalData"
        :loading="loading"
        :single-select="true"
        show-select
        class="elevation-1"
      >
        <template v-slot:[`item.mulai_pend`]="{ item }">
          {{ getCurrentDate(item.mulai_pend) }}
        </template>
        <template v-slot:[`item.akhir_pend`]="{ item }">
          {{ getAkhirKerja(item.akhir_pend) }}
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon medium class="mr-3" @click="editItem(item)">
            mdi-pencil
          </v-icon>
          <v-icon medium @click="deleteItem(item)"> mdi-delete </v-icon>
        </template>
      </v-data-table>
    </v-card>

    <!-- Modal -->
  </div>
</template>

<script>
import PendidikanService from "../../services/PendidikanService";
import * as moment from "moment";
import CommonService from "../../services/CommonService";

export default {
  props: {
    id: String,
  },
  data: () => ({
    childKey: 0,
    isEditable: 0,
    valid: true,
    tab: null,
    search: "",
    selected: [],
    headers: [
      {
        text: "No",
        align: "start",
        sortable: false,
        value: "no",
      },
      { text: "Jenjang", value: "jenjang_value", sortable: false },
      { text: "Nama Universitas", value: "nama_institusi", sortable: false },
      { text: "Mulai Pendidikan", value: "mulai_pend", sortable: false },
      { text: "Akhir Pendidikan", value: "akhir_pend", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
    ],
    isFirst: false,
    totalData: 0,
    list_data: [],
    loading: true,
    options: {
      itemsPerPage: 10,
      page: 1,
    },

    editedIndex: -1,
    editedItem: {},
    dialog: false,
    dialogDelete: false,

    currentFaskes: {
      nama: "",
    },

    currentData: {
      user_id: "",
      id: null,
      nama_institusi: "",
      jurusan: "",
      mulai_pend: "",
      akhir_pend: "",
      no_ijazah: "",
      tanggal_ijazah: "",
      selectedJenjang: "",
      namaRules: [(v) => !!v || "Judul harus diisi"],
      tanggalRules: [(v) => !!v || "Tanggal harus diisi"],
      jamAwalRules: [(v) => !!v || "Jam Awal harus diisi"],
      jamAkhirRules: [(v) => !!v || "Jam Akhir harus diisi"],

      items_jenjang: [],
    },

    layananList: [],
    currentLayanan: null,
  }),
  watch: {
    selected: {
      handler() {
        if (this.selected != undefined && this.selected[0]) {
          this.childKey++;
        }
      },
      deep: true,
    },
    options: {
      handler() {
        if (this.isFirst) {
          this.getDataFromApi();
        }
      },
      deep: true,
    },
  },
  mounted() {
    this.getListPendidikan();
    this.getDataFromApi();
  },
  methods: {
    getCurrentDate(tanggal) {
      return moment(tanggal).format("MMMM YYYY");
    },

    getAkhirKerja(tanggal) {
      if (tanggal == null) {
        return "Sampai saat ini";
      } else {
        return moment(tanggal).format("MMMM YYYY");
      }
    },

    async getDataFromApi() {
      console.log("get data from api");
      const { page, itemsPerPage } = this.options;

      this.loading = true;
      PendidikanService.pendidikanList(page, itemsPerPage, this.search, this.id)
        .then((res) => {
          console.log(res.data.list_data);
          this.list_data = res.data.list_data;
          this.totalData = res.data.total;
          this.loading = false;
          this.isFirst = true;
        })
        .catch((err) => {
          this.loading = false;
          this.isFirst = true;
          console.log(err);
        });
    },

    openTambah() {
      this.currentData.id = null;
      this.dialog = true;
      this.isEditable = 1;
    },

    editItem(item) {
      console.log(item);
      this.editedIndex = this.list_data.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.dialog = true;
      console.log(this.editedItem);

      this.currentData.id = this.editedItem.id;
      this.currentData.nama_institusi = this.editedItem.nama_institusi;
      this.currentData.jurusan = this.editedItem.jurusan;
      this.currentData.no_ijazah = this.editedItem.no_ijazah;

      this.currentData.mulai_pend = moment(this.editedItem.mulai_pend).format(
        "YYYY-MM"
      );

      this.currentData.akhir_pend = moment(this.editedItem.akhir_pend).format(
        "YYYY-MM"
      );

      this.currentData.tanggal_ijazah = moment(
        this.editedItem.tanggal_ijazah
      ).format("YYYY-MM-DD");

      if (this.editedItem.jenjang) {
        this.currentData.items_jenjang.forEach((entry) => {
          if (entry.code == this.editedItem.jenjang) {
            this.currentData.selectedJenjang = entry;
          }
        });
      }

      this.isEditable = 1;
    },

    doSave: async function () {
      if (!this.$refs.form.validate()) {
        return;
      }

      if (this.currentData.id == null) {
        this.currentData.user_id = this.id;
        PendidikanService.create(this.currentData)
          .then((res) => {
            console.log(res);
            this.dialog = false;

            CommonService.showSuccessToast("Tambah pendidikan berhasil");

            this.getDataFromApi();
          })
          .catch((err) => {
            console.log(err);

            CommonService.showSuccessToast(
              "Tambah pendidikan gagal. Coba lagi"
            );
          });
      } else {
        this.currentData.user_id = this.id;

        PendidikanService.update(this.currentData)
          .then((res) => {
            this.dialog = false;

            console.log(res);

            CommonService.showSuccessToast("Update pendidikan berhasil");

            this.getDataFromApi();
          })
          .catch((err) => {
            console.log(err);

            CommonService.showSuccessToast(
              "Update pendidikan gagal. Coba lagi"
            );
          });
      }
    },

    deleteItem(item) {
      console.log(item);
      this.editedIndex = this.list_data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.closeDelete();

      PendidikanService.delete(this.editedItem.id)
        .then((res) => {
          console.log(res);
          CommonService.showSuccessToast("Hapus pekerjaan berhasil");

          this.getDataFromApi();
        })
        .catch((err) => {
          console.log(err);
          CommonService.showSuccessToast("Hapus pekerjaan gagal. Coba lagi");
        });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    async getListPendidikan() {
      PendidikanService.masterPendidikan()
        .then((res) => {
          this.currentData.items_jenjang = res.data.list_data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
